import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Line } from 'react-chartjs-2';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
 // app config
import AppConfig from 'Constants/AppConfig';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


import { 
    fetchPlayerSpeed,
    fetchSpeedCheck,
    deleteSpeedCheck,
    studentSpeedCheck
 } from 'Actions';

 // chart config file
import ChartConfig from 'Constants/chart-config';

 import AddItem from '../../../technologyreport/speedcheck/component/addform';
 import EditItem from '../../../technologyreport/speedcheck/component/editform';

 import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
 import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

const toChartSeries = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    if (value === null || value === undefined || value === '') {
        return [];
    }
    if (typeof value === 'string') {
        return value.split(',').map((item) => item.trim());
    }
    return [value];
};

const buildLineChartData = (labels, series, borderColor, pointColor) => ({
    labels: toChartSeries(labels),
    datasets: [
        {
            fill: false,
            lineTension: 0,
            borderColor,
            borderWidth: 4,
            pointBorderColor: ChartConfig.color.white,
            pointBackgroundColor: pointColor,
            pointBorderWidth: 3,
            pointRadius: 6,
            pointHoverBackgroundColor: pointColor,
            pointHoverBorderColor: ChartConfig.color.white,
            pointHoverBorderWidth: 4,
            pointHoverRadius: 7,
            data: toChartSeries(series),
        },
    ],
});

class SpeedItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.nodeRef = React.createRef();
        this.confirmationDialog = React.createRef();
        this.state = {  
            student: this.props.data.student, 
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,  
            listdiv:true,
            reportdiv:false,
            adddiv:false,
            frmreport:this.props.data.frmreport,
            editdiv:false,
            alllstdiv1:false,
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
        this.onBacksection = this.onBacksection.bind(this); 
        this.onAddSession = this.onAddSession.bind(this);
        this.onListSession = this.onListSession.bind(this); 
        this.deleteForm = this.deleteForm.bind(this); 
    }

   
    onPrevSection(){

        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerSpeed(student, stdate, eddate);
        this.setState({
            reportdiv:false,
            adddiv:false,
            editdiv:false,
            alllstdiv1:false,
            listdiv:true, 
        }); 
    }

    onAddSession() {
        
		this.setState({ 
         listdiv:false,
         adddiv:true,
      });
    }
    
    onListSession() {   
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.studentSpeedCheck(student, stdate, eddate).then((data) => { 
            this.setState({ 
                sellst:1,   
                alllstdiv1:true,   
                listdiv:false,
                adddiv:false,
            });
        });    
    }

    onBacksection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerSpeed(student, stdate, eddate);

        this.setState({ 
            alllstdiv1:true,  
            editdiv:false,
            adddiv:false,
        });
    }

    editAssessment(gid){
        this.props.fetchSpeedCheck(gid).then((data) => {   
            var resdata=data.data;
            
            this.setState({ 
                seldate:resdata[0].tsc_date,  
                student:resdata[0].tsc_userID, 
                eid:resdata[0].tscID,          
              });


            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                alllstdiv1:false, 
                editdiv:true,
       
              });

        });
    }

    deleteForm(data){
      this.data = data;
      this.student=this.state.student;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteSpeedCheck(this.data);
            var student=this.student;
            this.props.fetchPlayerSpeed(student, '', '');
        }
    }



render() {
      
    const { playertechspeed, speedchecklist, loading} = this.props;
    const speedChart = playertechspeed && !Array.isArray(playertechspeed) ? playertechspeed : {};
    const labels = speedChart.label;
    const chartdata1 = speedChart.clubspeed;
    const chartdata2 = speedChart.ballspeed;
    const chartdata3 = speedChart.carry;

    const clubSpeedChart = buildLineChartData(labels, chartdata1, ChartConfig.color.info, ChartConfig.color.info);
    const ballSpeedChart = buildLineChartData(labels, chartdata2, ChartConfig.color.purple, ChartConfig.color.purple);
    const carryChart = buildLineChartData(labels, chartdata3, ChartConfig.color.warning, ChartConfig.color.warning);
    // chart options
    const options = {
        plugins:{
            legend: {
                display: false
            }
        },            
        scales: {
            x: {
                display: true,
                ticks: {
                    min: 0
                },
                gridLines: {
                    display: true,
                    drawBorder: false
                }
            },
            y:{
                display: true,
                ticks: {
                    suggestedMin: 0,
                    beginAtZero: true
                }
            }
        }
    };

    const stdrole = localStorage.getItem('stdrole');   
    const tableoptions = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "name", label: "NAME" },
        { name: "cdate", label: "DATE" },
        { name: "action", label: "ACTION" },
        { name: "action1", label: "ACTION1" },
      
    ];
    const tabledata = (Array.isArray(speedchecklist) ? speedchecklist : []).map((assmntval,idx) => {     
                 const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.tscID)}><EditOutlinedIcon/></IconButton>;
                 const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.tscID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
            no:idx+1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            action: ebtn,
            action1:dbtn,
            
            }
    });    
    

      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> SPEED CHECK</h1>
                </div>
                

                {this.state.listdiv && 
                    <>
                    <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                        <div className="ddd">
                            {stdrole==0 ? <div className="float-left"><a onClick={this.onAddSession} style={{color:"blue"}}><span class="icon-plus"></span> Add</a> <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.onListSession}><span class="icon-list"></span> List</a></div> : ""}
                            <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><KeyboardDoubleArrowLeftIcon aria-hidden="true" />  Back To Technology</Button></div>
                            {this.state.frmreport==1?<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Report</Button></div>:''}
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <RctCollapsibleCard>
                                    <h3 className="text-center">Club Speed</h3>
                                    <Line data={clubSpeedChart} options={options} height={150} /> 
                                </RctCollapsibleCard>      
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <RctCollapsibleCard>
                                    <h3 className="text-center">Ball Speed</h3>
                                    <Line data={ballSpeedChart} options={options} height={150} /> 
                                </RctCollapsibleCard>      
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <RctCollapsibleCard>
                                    <h3 className="text-center">Carry</h3>
                                    <Line data={carryChart} options={options} height={150} /> 
                                </RctCollapsibleCard>      
                            </div>
                        </div>
                    </div>
                    </>
                }
                

                {this.state.alllstdiv1 &&
                    <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="List" backtoadd onClick={this.onPrevSection} fullBlock>
                            <MUIDataTable
                                data={tabledata}
                                columns={columns}
                                options={tableoptions}
                            />
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.adddiv &&
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }

                {this.state.editdiv &&
                    <EditItem onClick={this.onPrevSection} data={this.state}/>
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'speed check'}
                />
            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention, speedcheck}) => {
    const { playertechspeed, loading } = playerintervention || {};
    const { speedchecklist = [] } = speedcheck || {};
    return { playertechspeed, speedchecklist, loading };
}


export default connect(mapStateToProps, {   
    fetchPlayerSpeed,
    fetchSpeedCheck,
    deleteSpeedCheck,
    studentSpeedCheck
})(SpeedItems);
